import { useState } from 'react'
import { useSelector } from 'react-redux'
import IconArrowRight from '../../../assets/icons/icon-arrow-right.svg'
import IconArrowDown from '../../../assets/icons/icon-arrow-down.svg'
import * as S from './styles'
import {
  capitalizeWord,
  convertDecimalCurrency,
  removeSecondsFromTime
} from '../../../utils/utils'
import MediaMatch from '../../MediaMatch'
import { Link, Router, useHistory } from 'react-router-dom'
import IconLink from '../../../assets/icons/icon-link.svg'
import useModal from '../../../hooks/useModal'

const TabelaGimplus = ({ data }) => {
  // const store = useSelector((reduxState) => reduxState)
  const { showModal } = useModal()
  const history = useHistory()

  const [showDetails, setShowDetails] = useState({
    showDetails: false
  })

  const [sortInfo, setSortInfo] = useState(['', false])

  const handleShowDetail = (cardDetail) => {
    setShowDetails({
      ...showDetails,
      [cardDetail]: !showDetails[cardDetail]
    })
  }

  function handleClick(item) {
    if (item.pedidoCliente === false && item.temPedido === true) {
      showModal({
        title: 'Atenção',
        description:
          'Você não pode consultar esse pedido de compra promovida por ser de outro usuário',
        type: 'message',
        confirmText: 'Fechar'
      })
    } else {
      history.push(`/meus-pedidos/${item.pedidoId}`)
    }
  }

  return (
    <>
      {data ? (
        <S.Wrapper>
          <S.TableDesktop>
            <thead>
              <tr>
                <th>Operação</th>
                <th
                  onClick={(e) => setSortInfo(['data', !sortInfo[1]])}
                  id="data"
                  className="sortable"
                >
                  Data
                </th>
                <th
                  onClick={(e) => setSortInfo(['totalPedido', !sortInfo[1]])}
                  id="totalPedido"
                  className="sortable"
                >
                  Valor
                </th>
                <th
                  onClick={(e) => setSortInfo(['pedidoId', !sortInfo[1]])}
                  id="pedidoId"
                  className="mobile-view sortable"
                >
                  Pedido
                </th>
                <th className="mobile-view">Observações</th>
              </tr>
            </thead>

            <tbody>
              {data
                ?.sort((a, b) => {
                  if (sortInfo[0] === 'data') {
                    let Ad = a[sortInfo[0]].split('/')
                    let Bd = b[sortInfo[0]].split('/')
                    let A = new Date(+Ad[2], +Ad[1], +Ad[0])
                    let B = new Date(+Bd[2], +Bd[1], +Bd[0])
                    return sortInfo[1] ? A - B : B - A
                  }
                  if (sortInfo[0] === 'stringCompare') {
                    if (a[sortInfo[0]] < b[sortInfo[0]])
                      return sortInfo[1] ? 1 : -1
                    if (a[sortInfo[0]] > b[sortInfo[0]])
                      return sortInfo[1] ? -1 : 1
                    return 0
                  }
                  let A = a[sortInfo[0]]
                  let B = b[sortInfo[0]]
                  return sortInfo[1] ? A - B : B - A
                })
                .map((item, index) => {
                  return (
                    <>
                      <tr
                        className="view"
                        key={`${item.pedidoId}-${index}`}
                        show={showDetails[index]}
                      >
                        <td>
                          <S.Badge type={item.tipoOperacao}>
                            {capitalizeWord(item.tipoOperacao)}
                          </S.Badge>
                        </td>

                        <td>
                          {item.data} - {removeSecondsFromTime(item.hora)}
                        </td>

                        <td>
                          {item.tipoOperacao === 'CRÉDITO' ? (
                            <strong class="text-color-green">
                              + {convertDecimalCurrency(item.valorPontos)}
                            </strong>
                          ) : (
                            <strong class="text-color-red">
                              - {convertDecimalCurrency(item.valorPontos)}
                            </strong>
                          )}

                          {item.pedidoId === 0 ||
                          item.pedidoId === null ? null : (
                            <button
                              className="link detail-arrow"
                              onClick={() => {
                                handleShowDetail(index)
                              }}
                            >
                              {showDetails[index] === true ? (
                                <img src={IconArrowDown} alt="" />
                              ) : (
                                <img src={IconArrowRight} alt="" />
                              )}
                            </button>
                          )}
                        </td>

                        <td className="mobile-view">
                          {' '}
                          {item.pedidoId === 0 || item.pedidoId === null ? (
                            '-'
                          ) : (
                            <Link onClick={() => handleClick(item)}>
                              <u>{item.pedidoId}</u>
                            </Link>
                          )}
                        </td>

                        <td className="mobile-view description">
                          {capitalizeWord(item.descricao)}
                          {item.pedidoId === 0 ||
                          item.pedidoId === null ? null : (
                            <button
                              className="link"
                              onClick={() => {
                                handleShowDetail(index)
                              }}
                            >
                              Detalhes
                              {showDetails[index] === true ? (
                                <img
                                  className="detail-arrow-desk"
                                  src={IconArrowDown}
                                  alt=""
                                />
                              ) : (
                                <img
                                  className="detail-arrow-desk"
                                  src={IconArrowRight}
                                  alt=""
                                />
                              )}
                            </button>
                          )}
                        </td>
                      </tr>

                      <S.Details
                        className="view-details"
                        key={index}
                        show={item.pedidoId !== 0 ? showDetails[index] : false}
                      >
                        <td colSpan="5">
                          <ul>
                            <li>
                              Pedido:{' '}
                              <strong>
                                {item.pedidoId === 0 || item.pedidoId === null
                                  ? '-'
                                  : item.pedidoId}
                              </strong>
                            </li>
                            <li>Data: {item.data}</li>
                            <li>
                              Valor Produtos:{' '}
                              {convertDecimalCurrency(item.totalPedido)}
                            </li>
                            <MediaMatch greaterThan="1171px">
                              <li>
                                {/* <Link to={`/meus-pedidos/${item.pedidoId}`}> */}
                                <Link onClick={() => handleClick(item)}>
                                  <button className="link link-pedido">
                                    Ver detalhes do Pedido
                                  </button>
                                </Link>
                              </li>
                            </MediaMatch>
                            <MediaMatch lessThan="large">
                              <li>{capitalizeWord(item.descricao)}</li>
                              <Link onClick={() => handleClick(item)}>
                                <button className="link link-pedido-mobile">
                                  <img src={IconLink} alt="" />
                                  detalhes
                                </button>
                              </Link>
                            </MediaMatch>
                          </ul>
                        </td>
                      </S.Details>
                    </>
                  )
                })}
            </tbody>
          </S.TableDesktop>
        </S.Wrapper>
      ) : null}
    </>
  )
}

export default TabelaGimplus
